<template>
  <div class="wd-flex wd-flex-col wd-gap-2">
    <div v-if="googleHighlight" class="wd-flex wd-flex-wrap wd-gap-2">
      <div class="wd-h-6 wd-flex wd-items-center wd-gap-1 wd-px-2 wd-rounded wd-bg-orange50">
        <funnow-svg-icon image-path="fire.svg" max-width="16" color="white" />
        <span class="wd-text-xs wd-text-white">{{ googleHighlight.label }}</span>
      </div>

      <div class="wd-h-6 wd-flex wd-items-center wd-gap-1 wd-px-2 wd-rounded wd-bg-gray20">
        <funnow-svg-icon image-path="google-login.svg" max-width="16" />
        <span class="wd-text-xs wd-text-gray80">{{ $t('ai_google_rating', { rating: googleHighlight.rating }) }}</span>
      </div>
    </div>

    <ul class="wd-flex wd-flex-col wd-gap-2 ai-summary-list">
      <li v-for="item in summaryItems" :key="item.labelKey" class="wd-flex wd-items-start">
        <funnow-svg-icon image-path="shiny.svg" max-width="24" />
        <p class="wd-text-base ai-summary-item">
          <span class="wd-font-bold">{{ $t(item.labelKey) }}</span
          >{{ item.description }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import FunnowSvgIcon from '@/components/icons/funnow-svg-icon.vue'
import type { BranchReviewSummaryItem, BranchReviewHighlightItem } from '@/types/api'

interface SummaryItem {
  labelKey: string
  enabled: boolean
  description?: string
}

interface Props {
  googleHighlight?: BranchReviewHighlightItem
  productUsp?: BranchReviewSummaryItem
  vibeService?: BranchReviewSummaryItem
}

const props = defineProps<Props>()

const summaryItems = computed<SummaryItem[]>(() => {
  const items: SummaryItem[] = [
    { labelKey: 'ai_google_subtitle1', enabled: !!props.productUsp, description: props.productUsp?.description },
    { labelKey: 'ai_google_subtitle2', enabled: !!props.vibeService, description: props.vibeService?.description },
  ]
  return items.filter(item => item.enabled)
})
</script>

<style scoped>
/* 覆蓋 .v-application 的 ul/p 預設樣式，util class 會被蓋掉 */
.ai-summary-list {
  padding-left: 0;
}

.ai-summary-item {
  margin: 0;
}
</style>
